<app-table [columns]="columns" [loading]="loading" [value]="markets" filename="MENU.MARKETS">
  <ng-template
    (onClick)="createNewMarket()"
    appToolbarButton
    icon="fal fa-plus"
    labelKey="MARKETS.CREATE_MARKET"></ng-template>
  <ng-template
    (onClick)="deleteMarket($event.row)"
    appActionButton
    displayIf="deletable"
    icon="fal fa-trash"
    labelKey="MARKETS.DELETE_HEADER"
    type="danger"></ng-template>
</app-table>
